<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { useMeta } from "vue-meta";
import { useI18n } from "vue-i18n";
import { useRouter } from 'vue-router';

const router = useRouter();
const { locale } = useI18n();

useMeta({
  htmlAttrs: { lang: locale.value, amp: true },
});

const isLoaded = ref(false);

onMounted(async () => {
  console.log('App mounted');
  try {
    await router.isReady();
    isLoaded.value = true;
    console.log('Router ready, app loaded');
  } catch (error) {
    console.error('Router failed to initialize:', error);
    isLoaded.value = true; // Still show content even if router fails
  }
});
</script>

<template>
  <div class="app-container">
    <Suspense>
      <RouterView v-if="isLoaded" />
      <template #fallback>
        <div>Loading...</div>
      </template>
    </Suspense>
  </div>
</template>


<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Chakra+Petch:wght@300;400;500;600;700&display=swap');

:root {
  --font-primary: 'Poppins', sans-serif;
  --font-secondary: 'Chakra Petch', sans-serif;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app-container {
  font-family: var(--font-primary);
}

main {
  background-color: black;
}

/* Utility classes for fonts */
.font-primary {
  font-family: var(--font-primary) !important;
}

.font-secondary {
  font-family: var(--font-secondary) !important;
}
</style>
